import EventEmitter from 'events'
import store from '@/store'

export default class Peer extends EventEmitter {

  constructor({ peerId, aboriginal = false }) {

    super()

    this.id = peerId
    this.aboriginal = aboriginal
    this.dataConnection = null
    this.mediaCall = null
    this.mediaStream = null
    this.enabledMic = false
    this.enabledVideo = false

    // 自分が画面共有している際の対全員へのMediaConnection
    this.displayCall = null
  }

  setMediaCall(call) {
    call.on('stream', (remoteStream) => {
      this.mediaStream = remoteStream
    })

    call.on('close', () => {
      this.emit('close')
    })

    this.mediaCall = call
  }

  setDisplayCall(call) {
    this.displayCall = call
  }

  setDataConnection(conn, onOpenCallback = null) {
    conn.on('open', () => {
      if (onOpenCallback) onOpenCallback()
      conn.on('data', (data) => {
        if (data.__proto__  === ArrayBuffer.prototype) {
          store.dispatch('whiteboard/receiveImageData', data)
        } else {
          const parsedData = JSON.parse(data)

          switch (parsedData.type) {
            case 'mediaState': {
              this.enabledMic = !!parsedData.enabledMic
              this.enabledVideo = !!parsedData.enabledVideo
              break
            }
            case 'whiteboard': {
              store.commit('whiteboard/setReceivedData', parsedData)
              break
            }
            case 'projectorOff': {
              store.commit('projector/removeStream')
              break
            }
            case 'minutes': {
              store.commit('minutes/setText', parsedData.text)
              break
            }
          }
        }
      })
    })

    this.dataConnection = conn
  }

  removeDisplayCall() {
    this.dataConnection.send(JSON.stringify({
      type: 'projectorOff'
    }))
    if (this.displayCall) {
      this.displayCall.close()
      this.displayCall = null
    }
  }

}
